import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTEPATHS } from './routes/routePaths';
import { useStoreState } from 'pullstate';
import DslStore from './store/DslStore';
import { getStrapiPaths } from './store/Selectors';
import Signup from './routes/signup';
import Signin from './routes/signin';
import GenericStrapi from './routes/GenericStrapi';
import Library from './routes/library';
import Typography from './routes/typography';
import Images from './routes/images';
import Buttons from './routes/buttons';
import Cards from './routes/cards';
import Forms from './routes/forms';
import Components from './routes/components';
import Community from './routes/community';
import ContestList from './routes/contest/ContestList';
import DesignDetails from './routes/contest/DesignDetails';
import Partners from './routes/partners';
import UploadDesign from './routes/profile/Design';
import CommunitySearch from './routes/communitySearch';
import ClientContest from './routes/profile/ClientContest';
import ContestPortfolio from './routes/profile/ContestPortfolio';
import Home from './routes/Home';
import PageNotFound from './routes/PageNotFound';
import ProfilePreview from './routes/profile/ProfilePreview';
import UploadInspiration from './routes/contest/UploadInspiration';
import ContactUs from './routes/ContactUs';
import EditDraft from './routes/contest/EditDraft';
import DesignerInspirationUpload from './routes/profile/DesignerInspirationUpload';
import ProfileSkeleton from './routes/profile/ProfileSkeleton';
import ContestSkeleton from './routes/contest/ContestSkeleton';
import ChooseUsername from './routes/chooseUsername';
import SearchResults from './routes/SearchResults';

const Container = () => {
  const strapiPath = useStoreState(DslStore, getStrapiPaths);
  const [strapiMenu, setStrapiMenu] = useState(['']);

  useEffect(() => {
    let tempMenu: string[] = [];
    // console.log(strapiPath);
    strapiPath.map((item: string) => tempMenu.push(item.replace('/', '')));
    setStrapiMenu(tempMenu);
    // console.log(tempMenu);
  }, [strapiPath]);

  return (
    <Routes>
      {strapiPath.map((item: string, index: number) => (
        // console.log(item),
        <Route path={`${item}/:title`} element={<GenericStrapi />} key={index}>
          {strapiMenu.map((menu: string, index: number) => (
            <Route path={`${menu}`} element={<GenericStrapi />} key={index}>
              <Route path={`*`} element={<GenericStrapi />} />
            </Route>
          ))}
        </Route>
      ))}

      <Route path={ROUTEPATHS.HOME} element={<Home />} />

      <Route path={ROUTEPATHS.CONTACT_US} element={<ContactUs />} />
      <Route path={ROUTEPATHS.SIGNUP} element={<Signup />} />
      {/* <Route path={`${ROUTEPATHS.SIGNUP}/linkedin`} element={<LinkedInCallback />} /> */}
      <Route path={`${ROUTEPATHS.SIGNUP}/:huntercode`} element={<Signup />} />
      <Route path={`${ROUTEPATHS.CHOOSEUSERNAME}`} element={<ChooseUsername />} />

      <Route path={ROUTEPATHS.SIGNIN} element={<Signin />} />
      {/* <Route path={ROUTEPATHS.TEST} element={<Test/>} /> */}
      {/* <Route path={ROUTEPATHS.TEST2} element={<Test2/>} /> */}
      {/* <Route path={ROUTEPATHS.TEST3} element={<GenericStrapi/>} /> */}
      {/* <Route path={`${strapiPath}/:title`} element={<GenericStrapi />} /> */}

      {/* Component Library */}
      <Route path={ROUTEPATHS.LIBRARY} element={<Library />} />
      <Route path={ROUTEPATHS.TYPOGRAPHY} element={<Typography />} />
      <Route path={ROUTEPATHS.IMAGES} element={<Images />} />
      <Route path={ROUTEPATHS.BUTTONS} element={<Buttons />} />
      <Route path={ROUTEPATHS.CARDS} element={<Cards />} />
      <Route path={ROUTEPATHS.FORMS} element={<Forms />} />
      <Route path={ROUTEPATHS.COMPONENTS} element={<Components />} />

      {/* Main pages */}
      <Route path={ROUTEPATHS.COMMUNITY} element={<Community />} />
      {/* <Route path={ROUTEPATHS.INFO_COMPANIES} element={<InfoCompanies />} /> */}

      {/* Contest */}
      <Route path={ROUTEPATHS.CONTEST} element={<ContestList />} />
      {/* <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_BRIEF}`} element={<Brief />} /> */}
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_BRIEF}`} element={<ContestSkeleton />} />
      <Route
        path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_INSPIRATIONS}`}
        element={<ContestSkeleton />}
      />
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_INSPIRATIONS}/edit`}
        element={<ContestSkeleton />} />
      <Route
        path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CREATE_INSPIRATION}`}
        element={<ContestSkeleton />}
      />
      {/* <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_AWARDS}`} element={<Awards />} /> */}
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_AWARDS}`} element={<ContestSkeleton />} />
      {/* <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_GALLERY}`} element={<Gallery />} /> */}
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_GALLERY}`} element={<ContestSkeleton />} />
      {/* <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_UPLOAD}`} element={<UploadContest />} /> */}
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_UPLOAD}`} element={<ContestSkeleton />} />

      {/* <Route path={ROUTEPATHS.CONTEST_BRIEF} element={<Brief />} /> */}
      {/* <Route path={ROUTEPATHS.CONTEST_INSPIRATIONS} element={<Inspirations />} /> */}
      {/* <Route path={ROUTEPATHS.CONTEST_AWARDS} element={<Awards />} /> */}
      {/* <Route path={ROUTEPATHS.CONTEST_GALLERY} element={<Gallery />} /> */}
      {/* <Route path={ROUTEPATHS.CONTEST_UPLOAD} element={<UploadContest />} /> */}

      {/* Design */}
      <Route
        path={`${ROUTEPATHS.CONTEST}/:nameForUrl/${ROUTEPATHS.CONTEST_GALLERY}/:name`}
        element={<DesignDetails />}
      />

      {/* Creatives */}
      {/* <Route path={ROUTEPATHS.INFO_CREATIVES} element={<InfoCreatives />} /> */}
      {/* <Route path={ROUTEPATHS.INFO_CREATIVES_ADDITIONAL} element={<AdditionalInfoCreatives />} /> */}
      {/* <Route path={ROUTEPATHS.INFO_CREATIVES_DREAMTEAM} element={<DreamTeam />} /> */}
      {/* <Route path={ROUTEPATHS.INFO_CREATIVES_ABOUT} element={<About />} /> */}
      <Route path={ROUTEPATHS.INFO_CREATIVES_PARTNERS} element={<Partners />} />

      {/* Companies */}
      {/* <Route path={ROUTEPATHS.COMPANIES_CASE_STUDIES} element={<CompaniesCaseStudies />} /> */}
      {/* <Route path={ROUTEPATHS.COMPANIES_MARKET} element={<OnMarket />} /> */}

      {/* Community */}

      {/* <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE}`} element={<Profile />} /> */}
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE}`} element={<ProfileSkeleton />} />
      {/* <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_EDITABLE}`}
        element={<ProfileEditable />}
      /> */}
      {/* <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`} element={<Portfolio />} /> */}
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`}
        element={<ProfileSkeleton />}
      />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_DESIGN}`} element={<UploadDesign />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}${ROUTEPATHS.COMMUNITY_SEARCH}`} element={<CommunitySearch />} />
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PORTFOLIO}/:design`}
        element={<EditDraft />}
      />

      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_EDITABLE}`}
        // element={<ProfileEditable />}
        element={<ProfileSkeleton />}
      />

      {/* Client */}
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.CLIENT_CONTESTS}`} element={<ClientContest />} />

      {/* Designer */}
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.DESIGNER_INSPIRATIONS}`}
        // element={<DesignerInspirations />}
        element={<ProfileSkeleton />}
      />
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.DESIGNER_INSPIRATIONS}/New`}
        element={<ProfileSkeleton />}
      />
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.DESIGNER_INSPIRATIONS}/Edit`}
        element={<ProfileSkeleton />}
      />
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.DESIGNER_CONTEST_PORTFOLIO}`}
        element={<ContestPortfolio />}
      />
      <Route
        path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`}
        element={<ProfilePreview />}
      />
      {/* <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.USER_FAVORITES}`} element={<UserFavorites />} /> */}
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.USER_FAVORITES}`} element={<ProfileSkeleton />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.USER_AWARDS}`} element={<ProfileSkeleton />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.USER_AMBASSADOR}`} element={<ProfileSkeleton />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.USER_BADGE}`} element={<ProfileSkeleton />} />
      
      
      <Route path={`/Search`} element={<SearchResults/>} />
      <Route path={`/Search/community`} element={<SearchResults/>} />
      <Route path={`/Search/design`} element={<SearchResults/>} />
      <Route path={`/Search/contest`} element={<SearchResults/>} />
      {/* Unknown path */}
      <Route path={`/PageNotFound`} element={<PageNotFound />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
export default Container;
